import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import LoanData from "../../../components/loanData";
import GuaranteeData from "../../../components/guaranteeData";
import {numberWithCommaDataTableTemplate} from "../../../utils/formatters/Numbers";
import HeaderPage from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import LoadingOverlay from "react-loading-overlay";

const DetailLoan = ({...props}) => {
    return (
        <React.Fragment>
            <LoadingOverlay
                active={props.isLoading}
                spinner
                text='Loading...'
            >

                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TitlePage title="Tablero de Control \ Detalles"/>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                label="Regresar"
                                style={{'float': 'right'}}
                                className="p-button-secondary"
                                onClick={props.handleReturnButton}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <LoanData
                            ref={props.loanData}
                            loanId={props.loanId}
                            selectedLoan={props.selectedLoan}
                            loading={props.loading}
                        />
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <GuaranteeData
                            loanId={props.loanId}
                            loading={props.loading}
                            loanStatusPV={props.selectedLoan.statusPV}
                        />
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <HeaderPage header="Instrucciones de Liquidación" isBold={true}/>
                            </Grid>
                            {
                                props.isAutomaticInstructions &&
                                <Grid
                                    item xs={6}>
                                    <Button
                                        label="Rechazar"
                                        style={{'float': 'right'}}
                                        className="p-button-secondary"
                                        onClick={props.handleRejectButton}/>
                                </Grid>
                            }
                            <Grid item xs={12}>
                                <DataTable
                                    value={props.settlementStatusList}
                                    resizableColumns={true}
                                    columnResizeMode={"fit"}>
                                    <Column field="emisora" header="Emisora"
                                            style={{textAlign: 'left'}} sortable={true}/>
                                    <Column field="cantidad" header="Títulos"
                                            style={{textAlign: 'right'}}
                                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                                    <Column field="ptm" header="PTM"
                                            style={{textAlign: 'left'}} sortable={true}/>
                                    <Column field="ptt" header="PTT"
                                            style={{textAlign: 'left'}} sortable={true}/>
                                    <Column field="fid" header="FID"
                                            style={{textAlign: 'left'}} sortable={true}/>
                                </DataTable>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </LoadingOverlay>
        </React.Fragment>
    )
};

export default DetailLoan;